import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './ProductPatternPage.css';
import palakImage from '../images/palak-logo.png';
import palakNidhi from "../images/palak-nidhi-img.jpeg"
const varieties = [
  {
    name: 'NIDHI',
    image:palakNidhi,
    description: [
      'F1 hybrid with premium dark green, crispy, non-brittle, broad leaves and exceptionally low odour',
      'Maturity: 35-40 days after sowing',
      'Premier multi-cut variety yielding an average of 5-6 cuttings, extending up to 8-10 under ideal management',
      'Production potential: 12-15 tonnes per acre',
      'Highly cold-resistant and excellent for winter and fall cultivation',
      'Pre-soak seeds in water for 12-24 hours to improve germination',
      'Seed rate: 4-6 kg per acre for winter and 10-15 kg per acre for summer',
      'Sowing depth: 3-4 cm with 20 cm row spacing',
    ],
  },
];

export default function PalakPage() {
  return (
    <ProductPatternPage
      title="Palak"
      varieties={varieties}
      pageClass="palak-page"
      heroImage={palakImage}
    />
  );
}
